import { useSelector } from 'react-redux';
import { getVideoParams, getVideoTime, getVideoUrl } from './index';

export const useVideoDialog = () => useSelector(getVideoUrl);
export const useVideoParams = () => useSelector(getVideoParams);
export const useVideoTime = () => useSelector(getVideoTime);
